var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "custom-autocomplete" },
        [
          _c("label", { staticClass: "data-label" }, [
            _vm._v(" " + _vm._s(_vm.label) + " ")
          ]),
          _c("autocomplete", {
            ref: "autocompleteRef",
            staticClass: "custom-autocomplete__input",
            class: { "is-invalidated": _vm.error },
            attrs: {
              "auto-select": true,
              "debounce-time": _vm.debounceTime,
              "default-value": _vm.value,
              disabled: _vm.disabled,
              "get-result-value": _vm.getResultValue,
              placeholder: _vm.placeholder,
              search: _vm.onSearch
            },
            on: { input: _vm.onChangeHandler, submit: _vm.submit },
            scopedSlots: _vm._u([
              {
                key: "result",
                fn: function({ result, props }) {
                  return [
                    _vm.displayTextName
                      ? _c(
                          "div",
                          _vm._b(
                            { staticClass: "custom-autocomplete__result" },
                            "div",
                            props,
                            false
                          ),
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "custom-autocomplete__result__title cursor-pointer"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(result[_vm.displayTextName]) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _c(
                          "div",
                          _vm._b(
                            {
                              staticClass:
                                "custom-autocomplete__custom-result px-3 py-1"
                            },
                            "div",
                            props,
                            false
                          ),
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center cursor-pointer"
                              },
                              [
                                _c("div", { staticClass: "flex-flex-grow-1" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-black font-14 font-weight-bold"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              result.fullName
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-gray-6 font-14 font-italic"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(result.userName) +
                                          " / " +
                                          _vm._s(result.email) +
                                          " "
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                  ]
                }
              }
            ])
          }),
          _vm.inputValue && _vm.showClear
            ? _c(
                "div",
                {
                  staticClass: "custom-autocomplete__clear cursor-pointer",
                  on: { click: _vm.onClearHandler }
                },
                [_c("em", { staticClass: "fas fa-times-circle" })]
              )
            : _vm._e()
        ],
        1
      ),
      _vm.error
        ? _c("error", {
            class: _vm.errorClass,
            attrs: { message: _vm.errorMessage, variant: "no-border" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }